import LeftSidebarContainer from "../../../Components/Blog/LeftSidebar";

const LeftSidebar = () => {
  return <LeftSidebarContainer />;
};

export default LeftSidebar;
